import { render } from "./infos.vue?vue&type=template&id=fb860064&scoped=true"
import script from "./infos.vue?vue&type=script&lang=js"
export * from "./infos.vue?vue&type=script&lang=js"

import "./infos.vue?vue&type=style&index=0&id=fb860064&scoped=true&lang=css"

import exportComponent from "D:\\ct-construction-ts-mobile\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fb860064"]])

export default __exports__